module.exports = __webpack_public_path__ + "images/home/product/wechat-miniprogram-notification-e5b679296a20bae84715465bbf68ada1.png";